<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Doc — Emissão
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica a
        strong  emissão completa
        |  de um documento: escolher o tipo, o modelo e percorrer todas as
        |  etapas do wizard até
        strong  Salvar
        | .
      p
        | Exemplo usado neste manual: cadastro com CNPJ
        strong  09.427.889/0001-62
        |  (Mobiliário), tipo
        strong  Notificação/Auto
        | , modelo de Não Conservação de Imóveis.

      .toast.toast-primary
        | Exige a permissão
        strong  Fiscalização → Documentos → Criar
        | .

      h5.h5 1. Escolher o tipo
      ol
        li Em
          strong  Doc → Documentos
          | , clique no botão
          code  +
          | .
        li No menu, escolha o tipo (ex.:
          strong  Notificação/Auto
          | ).
      figure.manual-figure
        img(:src="imgTipos" alt="Menu de tipos para emissão de documento")

      h5.h5 2. Escolher o modelo
      figure.manual-figure
        img(:src="imgModelo" alt="Seleção do modelo de documento")
      ol
        li Filtre por ID ou descrição/título, se quiser.
        li Clique no modelo desejado para iniciar o wizard.

      h5.h5 3. Informações (campos obrigatórios)
      figure.manual-figure
        img(:src="imgInfo" alt="Etapa Informações do documento preenchida")
      p Campos principais:
      ul
        li
          strong Cadastro *
          |  — abra o seletor, informe o
          strong  CPF/CNPJ
          |  (ex.: 09427889000162), filtre e selecione o cadastro.
        li
          strong Local
          |  — preenche automaticamente com o cadastro (pode alterar).
        li
          strong Vistoria em
          |  e
          strong  Descrição/Motivação
          |  — opcionais, mas recomendados.
        li
          strong Fiscal *
          |  — normalmente já vem com o usuário logado.
        li
          strong Tipo *
          |  — definido pelo tipo escolhido no passo 1 (somente leitura).
        li
          strong Prazo para regularizar *
          |  — em dias (ex.: 15).
      ol
        li Preencha os obrigatórios até o botão
          strong  Avançar
          |  habilitar.
        li Clique em
          strong  Avançar
          | .

      h5.h5 4. Irregularidades
      figure.manual-figure
        img(:src="imgIrr" alt="Etapa Irregularidades com itens selecionados")
      ol
        li Ative pelo menos uma irregularidade aplicável ao caso.
        li Clique em
          strong  Avançar
          | .
      .toast.toast-warning
        | Se já existir Notificação/Auto em andamento para o
        strong  mesmo cadastro e irregularidade
        | , o sistema impede a emissão. Escolha outra irregularidade
        |  ou trate o documento já existente.

      h5.h5 5. Comentário
      figure.manual-figure
        img(:src="imgComentario" alt="Etapa Comentário com descrição e anexos")
      p Campos:
      ul
        li
          strong Realizado em
          |  — “Agora” ou outra data.
        li
          strong Situação
          |  — opcional.
        li
          strong Descrição *
          |  — texto do comentário (mínimo de caracteres exigido pelo sistema).
        li
          strong Anexos
          |  — fotos/arquivos. Alguns modelos exigem quantidade mínima de fotos
          |  (ex.: 4). Use
          strong  Adicionar Anexos
          |  e aguarde o upload.
      ol
        li Preencha a descrição e anexe as fotos exigidas.
        li Clique em
          strong  Avançar
          | .

      h5.h5 6. Textos
      figure.manual-figure
        img(:src="imgTextos" alt="Etapa Textos do documento")
      p Os textos do modelo (ex.: Descrição dos fatos, Orientações/Penalidades)
        |  já vêm preenchidos. Revise e, se o modelo permitir, edite pelo ícone
        |  de lápis. Depois clique em
        strong  Avançar
        | .

      h5.h5 7. Confirmar e salvar
      figure.manual-figure
        img(:src="imgConfirmar" alt="Etapa Confirmar com resumo da emissão")
      ol
        li Revise tipo, modelo, cadastro, irregularidades, comentário e textos.
        li (Opcional) Ative
          strong  Salvar como rascunho
          |  se ainda não quiser emitir de fato.
        li Clique em
          strong  Salvar
          | .

      h5.h5 8. Resultado
      figure.manual-figure
        img(:src="imgResultado" alt="Documento emitido na tela de exibição")
      p Após salvar, o sistema abre a tela do documento (ex.: número/ano,
        |  situação
        strong  Aguardando Ciência
        | ). A partir daí use o menu
        strong  Ações
        |  conforme os outros manuais Doc.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgTipos: require("@/assets/manuais/13-doc-emissao-tipos.png"),
      imgModelo: require("@/assets/manuais/13a-doc-emissao-modelo.png"),
      imgInfo: require("@/assets/manuais/13b-doc-emissao-info.png"),
      imgIrr: require("@/assets/manuais/13c-doc-emissao-irregularidades.png"),
      imgComentario: require("@/assets/manuais/13d-doc-emissao-comentario.png"),
      imgTextos: require("@/assets/manuais/13e-doc-emissao-textos.png"),
      imgConfirmar: require("@/assets/manuais/13f-doc-emissao-confirmar.png"),
      imgResultado: require("@/assets/manuais/13g-doc-emissao-resultado.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
